import { Config } from ".";

export const isAbsoluteImageSrc = (value?: string | null): boolean =>
    !!value && /^(https?:|data:|blob:)/i.test(value);

export const resolveImageSrc = (value?: string | null): string => {
    if (!value) {
        return "";
    }

    if (isAbsoluteImageSrc(value)) {
        return value;
    }

    return `${Config.fileStoreUrl}${value}`;
};
